import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import HomeNavBar from '../Component/HomeComponent/HomeNavBar'
import axios from 'axios'
import { hrport, hrmJobPort } from '../App'
import { ArrowLeft, MapPin, Clock, Calendar, IndianRupee, Building2, CheckCircle2, ChevronRight } from 'lucide-react'
import HrStore, { HrStorage } from '../Context/HrStore'
import RightAvailableJobs from '../Component/RightAvailableJobs'
import { motion } from 'framer-motion'

const ParticularCareerPage = () => {
    const { slug } = useParams()
    let { allJob } = useContext(HrStorage)
    let [jobDetails, setJobDetails] = useState()
    let [loading, setLoading] = useState(true)
    let navigate = useNavigate()

    let getParticularData = () => {
        setLoading(true)
        axios.get(`${hrmJobPort}/api/job_description/${slug}/`).then((response) => {
            setJobDetails(response.data)
            setLoading(false)
        }).catch((error) => {
            console.log(error, 'job');
            setLoading(false)
        })
    }
    
    useEffect(() => {
        getParticularData()
        window.scrollTo(0, 0)
    }, [slug])

    const handleApply = () => {
        if(jobDetails) {
            window.open(`${hrport}/Canditate_Registration_Form?source=meridahr&desig=${jobDetails.Title}&jobpk=${jobDetails.id}`, '_blank')
        }
    }

    if (loading) {
        return (
            <div className="min-h-screen bg-slate-50 flex flex-col">
                <div className='bg-[#01014C]'>
                    <HomeNavBar type='white' />
                </div>
                <div className="flex-1 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
                </div>
            </div>
        )
    }

    if (!jobDetails) return null;

    return (
        <div className='bg-slate-50 min-h-screen font-poppins' >
            <Helmet>
                <title>{`${jobDetails.Title} | Careers | Merida HR`}</title>
                <meta name="description" content={`Apply for ${jobDetails.Title} position at Merida HR Consulting. ${jobDetails.job_location} - ${jobDetails.job_type}.`} />
                <link rel="canonical" href={`https://www.meridahr.com/jobs/${slug}`} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "JobPosting",
                        "title": jobDetails.Title,
                        "description": jobDetails.Discription || jobDetails.Skills || jobDetails.Title,
                        "datePosted": jobDetails.created_at || "2026-06-17",
                        "validThrough": jobDetails.valid_through || "2027-06-17",
                        "employmentType": jobDetails.job_type === "Full-Time" || jobDetails.job_type === "Full Time" ? "FULL_TIME" : (jobDetails.job_type === "Part-Time" || jobDetails.job_type === "Part Time" ? "PART_TIME" : "CONTRACTOR"),
                        "hiringOrganization": {
                            "@type": "Organization",
                            "name": "Merida HR Consulting",
                            "sameAs": "https://www.meridahr.com/",
                            "logo": "https://www.meridahr.com/MeridaConsultancyLogo.png"
                        },
                        "jobLocation": {
                            "@type": "Place",
                            "address": {
                                "@type": "PostalAddress",
                                "addressLocality": jobDetails.job_location || "Bengaluru",
                                "addressRegion": "Karnataka",
                                "addressCountry": "IN"
                            }
                        },
                        "baseSalary": {
                            "@type": "MonetaryAmount",
                            "currency": "INR",
                            "value": {
                                "@type": "QuantitativeValue",
                                "value": jobDetails.Salary || "Negotiable",
                                "unitText": "MONTH"
                            }
                        }
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Home",
                                "item": "https://www.meridahr.com/"
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name": "Careers",
                                "item": "https://www.meridahr.com/careers"
                            },
                            {
                                "@type": "ListItem",
                                "position": 3,
                                "name": jobDetails.Title,
                                "item": `https://www.meridahr.com/jobs/${slug}`
                            }
                        ]
                    })}
                </script>
            </Helmet>
            
            {/* Dark Blue Header Section */}
            <div className='bg-[#01014C] pb-16 relative overflow-hidden'>
                {/* Background pattern */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '32px 32px' }}></div>
                </div>
                
                <div className="relative z-10">
                    <HomeNavBar type='white' />
                    
                    <main className='container mx-auto px-6 pt-10'>
                        <button 
                            onClick={() => navigate(`/careers`)} 
                            className='flex items-center gap-2 text-blue-200 hover:text-white transition-colors mb-8 text-sm font-medium'
                        >
                            <ArrowLeft size={16} />
                            Back to all jobs
                        </button>
                        
                        <div className="max-w-4xl">
                            <span className="inline-block py-1 px-3 rounded-full bg-blue-500/20 text-blue-300 text-xs font-bold tracking-widest uppercase mb-4 border border-blue-400/30">
                                {jobDetails.department_name || 'Open Position'}
                            </span>
                            <h1 className='text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight'>
                                {jobDetails.Title}
                            </h1>
                            
                            <div className='flex flex-wrap gap-4 text-blue-100 mb-8 items-center' >
                                <div className='flex items-center gap-2 font-medium bg-white/10 px-4 py-2 rounded-lg border border-white/10' >
                                    <Building2 size={18} className="text-blue-400" />
                                    {jobDetails.company_inrto || 'Merida HR'}
                                </div>
                                <div className='flex items-center gap-2 font-medium bg-white/10 px-4 py-2 rounded-lg border border-white/10' >
                                    <MapPin size={18} className="text-blue-400" />
                                    {jobDetails.job_location}
                                </div>
                                <div className='flex items-center gap-2 font-medium bg-white/10 px-4 py-2 rounded-lg border border-white/10' >
                                    <Clock size={18} className="text-blue-400" />
                                    {jobDetails.job_type}
                                </div>
                            </div>
                            
                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                                <button
                                    onClick={handleApply}
                                    className='bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-400 hover:to-blue-500 text-white font-bold py-4 px-10 rounded-full transition-all duration-300 shadow-lg shadow-blue-500/30 text-lg flex items-center gap-2 group' 
                                >
                                    Apply Now
                                    <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
                                </button>
                                
                                <p className="text-blue-200 text-sm">
                                    Posted: {new Date(jobDetails.posted_on).toLocaleString('en-GB', {
                                        day: '2-digit', month: 'short', year: 'numeric'
                                    })}
                                </p>
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            {/* Main Content */}
            <main className='container mx-auto px-6 py-12'>
                <div className='flex flex-col lg:flex-row gap-8 lg:gap-12' >
                    
                    {/* Left Column: Job Details */}
                    <section className='lg:w-2/3'>
                        {/* Quick Stats Grid */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10 -mt-20 relative z-20">
                            <div className="bg-white p-5 rounded-2xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-center text-center">
                                <div className="bg-blue-50 w-12 h-12 rounded-full flex items-center justify-center mb-3 text-blue-600">
                                    <IndianRupee size={24} />
                                </div>
                                <p className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">Salary</p>
                                <p className="text-slate-900 font-bold">
                                    {jobDetails.min_salary && (jobDetails.min_salary) + (jobDetails.salary_type || '')}
                                    {jobDetails.min_salary && jobDetails.max_salary && " - "}
                                    {jobDetails.max_salary && (jobDetails.max_salary) + (jobDetails.salary_type || '')}
                                </p>
                            </div>
                            <div className="bg-white p-5 rounded-2xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-center text-center">
                                <div className="bg-green-50 w-12 h-12 rounded-full flex items-center justify-center mb-3 text-green-600">
                                    <Calendar size={24} />
                                </div>
                                <p className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">Experience</p>
                                <p className="text-slate-900 font-bold">
                                    {jobDetails.min_exp && (jobDetails.min_exp) + " Yrs"}
                                    {jobDetails.min_exp && jobDetails.Experience && " - "}
                                    {jobDetails.Experience && (jobDetails.Experience) + " Yrs "}
                                </p>
                            </div>
                            <div className="bg-white p-5 rounded-2xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-center text-center">
                                <div className="bg-purple-50 w-12 h-12 rounded-full flex items-center justify-center mb-3 text-purple-600">
                                    <CheckCircle2 size={24} />
                                </div>
                                <p className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">Qualification</p>
                                <p className="text-slate-900 font-bold truncate w-full" title={jobDetails.Qualification}>
                                    {jobDetails.Qualification || 'N/A'}
                                </p>
                            </div>
                            <div className="bg-white p-5 rounded-2xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-center text-center">
                                <div className="bg-orange-50 w-12 h-12 rounded-full flex items-center justify-center mb-3 text-orange-600">
                                    <Clock size={24} />
                                </div>
                                <p className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">Employment</p>
                                <p className="text-slate-900 font-bold">
                                    {jobDetails.job_type || 'Full Time'}
                                </p>
                            </div>
                        </div>

                        {/* Job Description Content */}
                        <article className='bg-white shadow-xl shadow-blue-900/5 rounded-3xl p-8 md:p-12 border border-slate-100' >
                            <h2 className='text-2xl font-black text-slate-900 mb-6'>Job Description</h2>
                            <div
                                className='prose prose-blue max-w-none text-slate-600 mb-10 rich-text-content'
                                style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: jobDetails.Job_Discription }}
                            />
                            
                            {/* Responsibilities */}
                            {jobDetails.points && jobDetails.points.filter(obj => obj.point && obj.point.trim() !== '').length > 0 && (
                                <div className='mb-10'>
                                    <h3 className='text-xl font-black text-slate-900 mb-6'>Responsibilities and Role</h3>
                                    <ul className='space-y-4'>
                                        {jobDetails.points
                                            .filter(obj => obj.point && obj.point.trim() !== '')
                                            .map((obj, index) => (
                                                <li key={index} className='flex items-start gap-3 text-slate-600'>
                                                    <div className="mt-1 flex-shrink-0 text-blue-500"><CheckCircle2 size={18} /></div>
                                                    <span className="leading-relaxed">{obj.point}</span>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            )}

                            {/* Expertise */}
                            {jobDetails.expertise_points && jobDetails.expertise_points.filter(obj => obj.point && obj.point.trim() !== '').length > 0 && (
                                <div className='mb-10'>
                                    <h3 className='text-xl font-black text-slate-900 mb-6'>Expertise</h3>
                                    <ul className='space-y-4'>
                                        {jobDetails.expertise_points
                                            .filter(obj => obj.point && obj.point.trim() !== '')
                                            .map((obj, index) => (
                                                <li key={index} className='flex items-start gap-3 text-slate-600'>
                                                    <div className="mt-1 flex-shrink-0 text-blue-500"><CheckCircle2 size={18} /></div>
                                                    <span className="leading-relaxed">{obj.point}</span>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            )}

                            {/* Key Skills */}
                            {jobDetails.key_skills && jobDetails.key_skills.filter(obj => obj.skill && obj.skill.trim() !== '').length > 0 && (
                                <div>
                                    <h3 className='text-xl font-black text-slate-900 mb-4'>Key Skills</h3>
                                    <p className='text-sm text-slate-500 mb-6'>Skills highlighted with a star (⭐) are highly preferred.</p>
                                    <div className='flex flex-wrap gap-3'>
                                        {jobDetails.key_skills
                                            .filter(obj => obj.skill && obj.skill.trim() !== '')
                                            .map((obj, index) => (
                                                <span key={index} className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold border ${obj.is_required ? 'bg-amber-50 border-amber-200 text-amber-800' : 'bg-slate-50 border-slate-200 text-slate-700'}`}>
                                                    {obj.is_required && <span className="text-amber-500">⭐</span>}
                                                    {obj.skill}
                                                </span>
                                            ))}
                                    </div>
                                </div>
                            )}
                            
                            {/* Bottom CTA */}
                            <div className="mt-12 pt-10 border-t border-slate-100 flex justify-center">
                                <button
                                    onClick={handleApply}
                                    className='bg-slate-900 hover:bg-blue-600 text-white font-bold py-4 px-12 rounded-full transition-colors shadow-lg shadow-blue-900/20 text-lg flex items-center gap-2 group' 
                                >
                                    Apply For This Position
                                </button>
                            </div>
                        </article>
                    </section>

                    {/* Right Side: Similar Jobs */}
                    <aside className='lg:w-1/3' >
                        <div className='bg-white shadow-xl shadow-blue-900/5 border border-slate-100 rounded-3xl p-6 lg:p-8 sticky top-8'>
                            <h3 className='text-xl font-black text-slate-900 mb-6'>Similar Jobs</h3>
                            <RightAvailableJobs data={allJob} />
                        </div>
                    </aside>

                </div>
            </main>
        </div>
    )
}

export default ParticularCareerPage